import { ClipboardCheck } from 'lucide-react';

export function SheetsClipboardHint(): JSX.Element {
  return (
    <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
      <ClipboardCheck className="size-4 text-green-600 shrink-0" />
      <span>
        Данные скопированы — нажмите{' '}
        <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 text-xs font-mono">
          Ctrl+V
        </kbd>{' '}
        (
        <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 text-xs font-mono">
          ⌘V
        </kbd>
        ) в открывшейся таблице
      </span>
    </div>
  );
}
